var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7929 11.0273C14.5415 11.4655 11.3099 15.0474 11.3099 19.3212H17.0999V18.4969C17.0999 17.0634 18.1422 15.8733 19.5102 15.643V11.4305C19.5102 11.1753 19.2895 10.9762 19.0356 11.0023L18.7929 11.0273ZM17.0986 20.2126H11.3096V27.3162C11.3096 32.1115 15.1969 35.9988 19.9922 35.9988C24.7875 35.9988 28.6749 32.1115 28.6749 27.3162V20.2126H22.8871V21.036C22.8871 22.6344 21.5913 23.9302 19.9928 23.9302C18.3944 23.9302 17.0986 22.6344 17.0986 21.036V20.2126ZM19.991 16.4883C18.9254 16.4883 18.0615 17.3521 18.0615 18.4178V21.0671C18.0615 22.1327 18.9254 22.9966 19.991 22.9966C21.0566 22.9966 21.9205 22.1328 21.9205 21.0671V18.4178C21.9205 17.3521 21.0566 16.4883 19.991 16.4883Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1939 11.0273C25.4452 11.4655 28.6768 15.0474 28.6768 19.3212H22.8862V18.4969C22.8862 17.0636 21.8443 15.8737 20.4766 15.6431V11.4305C20.4766 11.1753 20.6973 10.9762 20.9511 11.0023L21.1939 11.0273Z",
    fill: "#BB86FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7104 8.97803L11.3576 7.30184C11.2102 7.22814 11.2102 7.01778 11.3576 6.94407L14.7104 5.26747C14.8434 5.20097 14.9999 5.29767 14.9999 5.44635V6.62305H24.9971V5.44664C24.9971 5.29796 25.1535 5.20126 25.2865 5.26775L28.6393 6.94393C28.7867 7.01763 28.7867 7.22799 28.6393 7.30171L25.2865 8.9783C25.1535 9.0448 24.9971 8.9481 24.9971 8.79942V7.62305H14.9999V8.79914C14.9999 8.94781 14.8434 9.04451 14.7104 8.97803Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.9d29987035917e26d336f31b83fe4cda.svg";
export { ForwardRef as ReactComponent };